import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner, Form, Button } from "react-bootstrap";

import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";

const Kemasan = () => {
  const columns = [
    {
      name: "Kode Kemasan",
      cell: (row) => row["kodeKemasan"],
    },
    {
      name: "Uraian Kemasan",
      cell: (row) => row["uraianKemasan"],
    },
  ];

  const masterService = useMemo(() => new MasterService(), []);

  const [listKemasan, setListKemasan] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [size, setSize] = useState(10);
  const [loading, setLoading] = useState(false);

  const getListKemasan = useCallback(async () => {
    setLoading(true);
    try {
      const response = await masterService.listKemasan(null, 0, 1000);
      const data = response.data.data;
      setListKemasan(data);
      setFilteredData(data); // set default tampilan
    } catch (error) {
      console.log(error);
      setListKemasan([]);
      setFilteredData([]);
    }
    setLoading(false);
  }, [masterService]);

  useEffect(() => {
    getListKemasan();
  }, [getListKemasan]);

  // 🔍 Pencarian berdasarkan uraian kemasan
  const handleSearchChange = (e) => {
    const keyword = e.target.value;
    setSearchText(keyword);

    if (keyword.trim() === "") {
      setFilteredData(listKemasan);
    } else {
      const filtered = listKemasan.filter((item) =>
        item.uraianKemasan?.toLowerCase().includes(keyword.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };

  const handleReset = () => {
    setSearchText("");
    setFilteredData(listKemasan);
  };

  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Pencarian Data</h4>
              </div>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-6">
                  <Form>
                    <Form.Group as={Row} className="form-group">
                      <Col sm="6">
                        <Form.Control
                          type="text"
                          placeholder="Cari Kemasan"
                          className="form-control-sm"
                          value={searchText}
                          onChange={handleSearchChange}
                        />
                      </Col>
                      <Col sm="2">
                        <Button
                          type="button"
                          variant="btn btn-danger"
                          size="sm"
                          onClick={handleReset}
                        >
                          Reset
                        </Button>{" "}
                      </Col>
                    </Form.Group>
                  </Form>
                </div>
              </div>
            </Card.Body>
          </Card>

          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Daftar Master Kemasan</h4>
              </div>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive border-bottom my-3">
                {loading && <Spinner />}
                <DataTable
                  customStyles={{
                    headCells: {
                      style: {
                        backgroundColor: "#00acee",
                        color: "white",
                      },
                    },
                  }}
                  columns={columns}
                  data={filteredData}
                  highlightOnHover
                  pagination
                  paginationPerPage={size}
                  onChangeRowsPerPage={(newSize) => setSize(newSize)}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Kemasan;
